module.exports = __webpack_public_path__ + "img/ria-profile.dcb12e3.jpeg";